
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const UserRole = {
  ADMIN: 'ADMIN',
  CREW: 'CREW'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const ShiftStatus = {
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
  INACTIVE: 'INACTIVE'
} as const

export type ShiftStatus = (typeof ShiftStatus)[keyof typeof ShiftStatus]


export const AssigneeRole = {
  PRIMARY: 'PRIMARY',
  COLLABORATOR: 'COLLABORATOR'
} as const

export type AssigneeRole = (typeof AssigneeRole)[keyof typeof AssigneeRole]


export const ProjectStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  ON_HOLD: 'ON_HOLD',
  COMPLETE: 'COMPLETE'
} as const

export type ProjectStatus = (typeof ProjectStatus)[keyof typeof ProjectStatus]


export const FieldCorrectionStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED'
} as const

export type FieldCorrectionStatus = (typeof FieldCorrectionStatus)[keyof typeof FieldCorrectionStatus]


export const PremiseType = {
  RESIDENTIAL: 'RESIDENTIAL',
  COMMERCIAL: 'COMMERCIAL'
} as const

export type PremiseType = (typeof PremiseType)[keyof typeof PremiseType]


export const FieldCorrectionType = {
  RELOCATE: 'RELOCATE',
  CREATE: 'CREATE',
  SKETCH: 'SKETCH',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  REDLINE: 'REDLINE'
} as const

export type FieldCorrectionType = (typeof FieldCorrectionType)[keyof typeof FieldCorrectionType]


export const TicketStatus = {
  PENDING: 'PENDING',
  EN_ROUTE: 'EN_ROUTE',
  ON_SITE: 'ON_SITE',
  IN_PROGRESS: 'IN_PROGRESS',
  ON_HOLD: 'ON_HOLD',
  CANCELLED: 'CANCELLED',
  FIELD_COMPLETE: 'FIELD_COMPLETE',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED'
} as const

export type TicketStatus = (typeof TicketStatus)[keyof typeof TicketStatus]


export const TicketPriority = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  URGENT: 'URGENT'
} as const

export type TicketPriority = (typeof TicketPriority)[keyof typeof TicketPriority]


export const CrewStatus = {
  AVAILABLE: 'AVAILABLE',
  BUSY: 'BUSY',
  UNAVAILABLE: 'UNAVAILABLE'
} as const

export type CrewStatus = (typeof CrewStatus)[keyof typeof CrewStatus]


export const AssignmentTypes = {
  MANUAL: 'MANUAL',
  AUTO: 'AUTO'
} as const

export type AssignmentTypes = (typeof AssignmentTypes)[keyof typeof AssignmentTypes]


export const AssignmentStatus = {
  UNASSIGNED: 'UNASSIGNED',
  PENDING_CLAIM: 'PENDING_CLAIM',
  ASSIGNED: 'ASSIGNED'
} as const

export type AssignmentStatus = (typeof AssignmentStatus)[keyof typeof AssignmentStatus]


export const CustomFieldType = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
  SELECT: 'SELECT'
} as const

export type CustomFieldType = (typeof CustomFieldType)[keyof typeof CustomFieldType]


export const CustomFieldEntity = {
  TICKET: 'TICKET',
  ASSET: 'ASSET'
} as const

export type CustomFieldEntity = (typeof CustomFieldEntity)[keyof typeof CustomFieldEntity]


export const AiReviewStatus = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PARTIAL: 'PARTIAL',
  PENDING: 'PENDING'
} as const

export type AiReviewStatus = (typeof AiReviewStatus)[keyof typeof AiReviewStatus]


export const GeometryType = {
  POINT: 'POINT',
  LINESTRING: 'LINESTRING',
  MULTIPOINT: 'MULTIPOINT',
  MULTIPOLYGON: 'MULTIPOLYGON',
  LINEARRING: 'LINEARRING',
  CIRCLE: 'CIRCLE',
  GEOMETRYCOLLECTION: 'GEOMETRYCOLLECTION',
  POLYGON: 'POLYGON',
  MULTILINESTRING: 'MULTILINESTRING'
} as const

export type GeometryType = (typeof GeometryType)[keyof typeof GeometryType]


export const AssetStatus = {
  IN_SERVICE: 'IN_SERVICE',
  PLANNED: 'PLANNED',
  REMOVED: 'REMOVED',
  DECOMMISSIONED: 'DECOMMISSIONED',
  PROPOSED: 'PROPOSED'
} as const

export type AssetStatus = (typeof AssetStatus)[keyof typeof AssetStatus]


export const FiberCableType = {
  BB: 'BB',
  RISER: 'RISER',
  LATERAL: 'LATERAL',
  DROP: 'DROP',
  CORE: 'CORE',
  DISTRIBUTION: 'DISTRIBUTION'
} as const

export type FiberCableType = (typeof FiberCableType)[keyof typeof FiberCableType]


export const FiberInstallationType = {
  UNDERGROUND: 'UNDERGROUND',
  AERIAL: 'AERIAL'
} as const

export type FiberInstallationType = (typeof FiberInstallationType)[keyof typeof FiberInstallationType]


export const FiberCableStatus = {
  IN_SERVICE: 'IN_SERVICE',
  ABANDONED: 'ABANDONED',
  VIRTUAL: 'VIRTUAL',
  IN_CONSTRUCTION: 'IN_CONSTRUCTION',
  LEASED: 'LEASED'
} as const

export type FiberCableStatus = (typeof FiberCableStatus)[keyof typeof FiberCableStatus]


export const FiberGlassType = {
  SM: 'SM',
  MM: 'MM',
  LF: 'LF',
  AW: 'AW',
  TW: 'TW'
} as const

export type FiberGlassType = (typeof FiberGlassType)[keyof typeof FiberGlassType]


export const FiberArmor = {
  DIELECTRIC: 'DIELECTRIC',
  ARMORED: 'ARMORED'
} as const

export type FiberArmor = (typeof FiberArmor)[keyof typeof FiberArmor]
